<template>
	<q-page padding class="bg-white">
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-user" class="q-mb-sm" /> {{ $t(page_title) }}
		</div>

		<div class="row gutter-xs">
			<div class="col-xs-12 col-sm-12">
				<span class="q-headline text-weight-light">{{ $t('personal_data') }}</span>
			</div>

			<div class="col-12">
				<q-field
					:error="register_error"
					:error-label="
						register_error
							? register_error_message
								? $t(register_error_message)
								: custom_error_message
							: ''
					"
				>
					<q-input
						v-model="register"
						:float-label="$t('register')"
						:error="$v.register.$error"
						@input="$v.register.$touch"
						@blur="registerUnique()"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-input v-model="full_name" :float-label="$t('name')" disable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-field :error="email_error">
					<span slot="error-label" v-if="email_error">
						{{ $t('email_already_in_use_click') }}
						<router-link to="recover-password">{{ $t('here') }}</router-link>
						{{ $t('to_recover_your_password') }}
					</span>

					<q-input
						v-model="email"
						type="email"
						:float-label="$t('email')"
						:error="$v.email.$error"
						@input="$v.email.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input
					v-model="email_confirm"
					type="email"
					:float-label="$t('email_confirm')"
					:error="$v.email_confirm.$error"
					@input="$v.email_confirm.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-6">
				<!-- <q-input type="password" v-model="password" :float-label="$t('password')" /> -->
				<q-field :helper="$t(getPasswordHelper)" :error="$v.password.$error">
					<q-input
						v-model="password"
						:float-label="$t('password')"
						type="password"
						:error="$v.password.$error"
						@input="$v.password.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input
					type="password"
					v-model="password_confirm"
					:float-label="$t('confirm_password')"
				/>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'login' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<q-dialog v-model="show_error" @ok="show_error = false" :cancel="false">
			<span slot="title">{{ $t('register_error') }}</span>

			<span slot="message">{{ $t('user_doesnt_have_access') }}</span>
		</q-dialog>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import { required, requiredIf, email, sameAs } from 'vuelidate/lib/validators'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
const { formatDate } = date

export default {
	i18nOptions: { namespaces: ['common', 'login', 'users'] },

	data() {
		return {
			page_title: 'user_register',
			register: '',
			register_error: false,
			full_name: '',
			email: '',
			email_error: false,
			email_confirm: '',
			email_confirm_error: false,
			password: '',
			password_confirm: '',
			user_created: false,
			register_error_message: '',
			custom_error_message: '',
			show_error: false,
		}
	},

	computed: {
		...mapGetters({
			login_user_pre_register: 'params/login_user_pre_register',
			login_user_register: 'params/login_user_register',
			register_fields: 'params/register_fields',
			register_others: 'params/register',
			languages: 'params/languages',
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_language_selected: 'common/id_user_language_selected',
			login_oauth2: 'params/login_oauth2',
			password_strong_level: 'params/password_strong_level',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
				},
			})
		},

		getAuthHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		getPasswordHelper() {
			if (this.password_strong_level == 'strong') {
				return 'helper_password_strong'
			} else if (this.password_strong_level == 'medium') {
				return 'helper_password_medium'
			} else {
				return 'helper_password_low'
			}
		},
	},

	methods: {
		saveData() {
			let has_errors = false
			this.$v.$touch()

			if (!this.$v.$error && !has_errors) {
				this.$q.loading.show()

				let data = {
					email: this.email,
					full_name: this.full_name,
					register: this.register,
					password: this.password,
					password_confirmation: this.password_confirm,
				}

				let url = ''

				if (this.$route.name === 'register-pop-trade')
					url = '/webservices/academiapoptrade/adicional_data/'
				else if (this.$route.name === 'register-seven-trade')
					url = '/webservices/academiaseventrade/adicional_data/'

				this.$axios
					.post(url, data, this.getHeader)
					.then((response) => {
						this.setUserData(response)
					})
					.catch((e) => {
						this.$q.loading.hide()
						this.show_error = true
						console.log(e)
					})
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		setUserData(response) {
			this.$store.dispatch('common/SET_ACCESS_TOKEN', [
				response.data.access_token,
				response.data.refresh_token,
				response.data.user_firebase_token,
			])

			if (response.data.user_firebase_token) {
				firebase
					.auth()
					.signInWithCustomToken(response.data.user_firebase_token)
					.then(() => {
						if (this.$q.platform.is.cordova) {
							this.setUserDeviceToken()
						} else {
							this.getWelcomeBanner()
						}
					})
					.catch(function(error) {
						var errorCode = error.code
						var errorMessage = error.message
					})
			} else {
				if (this.$q.platform.is.cordova) {
					this.setUserDeviceToken()
				} else {
					this.getWelcomeBanner()
				}
			}
		},

		setUserDeviceToken() {
			// window.plugins.OneSignal.getIds((ids) => {
			//     let fd = new FormData()
			//     fd.append('token', ids.userId)
			//     fd.append('device_type', this.$q.platform.is.android ? 'android' : 'ios')

			//     this.$axios.post('/etraining_login/set_user_device_token', fd, this.getAuthHeader)
			//     .then(response => {
			this.getWelcomeBanner()
			//     })
			//     .catch(e => {
			//         this.getWelcomeBanner()
			//         console.log(e)
			//     })
			// })
		},

		getWelcomeBanner() {
			this.$axios
				.get('/etraining_banners_welcome/banners_welcome/', this.getAuthHeader)
				.then((response) => {
					this.$store.dispatch('welcome_banner/SET_WELCOME_BANNER', [response.data])
					this.getUserData()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/', this.getAuthHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					const obj = this.clients.find(
						(obj) => obj.id === response.data.id_user_client_selected
					)
					if (obj) {
						if (this.$q.platform.is.cordova) {
							if (obj.home_route === 'home') {
								if (obj.has_courses) {
									this.$router.replace({ name: 'courses' })
								} else if (obj.has_trails) {
									this.$router.replace({ name: 'trails' })
								} else if (obj.has_library) {
									this.$router.replace({ name: 'library' })
								}
							} else {
								this.$router.replace({ name: obj.home_route })
							}
						} else {
							if (obj.home_route) {
								this.$router.replace({ name: obj.home_route })
							} else {
								if (obj.has_courses) {
									this.$router.replace({ name: 'courses' })
								} else if (obj.has_trails) {
									this.$router.replace({ name: 'trails' })
								} else if (obj.has_library) {
									this.$router.replace({ name: 'library' })
								}
							}
						}
					} else {
						this.$router.replace({ name: 'courses' })
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		registerUnique() {
			let obj = this.login_oauth2.find((obj) => {
				return obj.slug === 'academiapoptrade' || obj.slug === 'academiaseventrade'
			})
			if (this.register && obj) {
				this.register_error_message = ''

				let fd = new FormData()
				fd.append('username', this.register)

				this.$axios
					.post(obj.oauth_url, fd, this.getHeader)
					.then((response) => {
						if (!response.data.first_access) {
							this.register_error = true
							this.full_name = ''
							this.register_error_message =
								'user_is_already_registered_or_doesnt_have_access'
						} else {
							this.full_name = response.data.full_name
							this.register_error = false
						}
					})
					.catch((e) => {
						this.register_error = true
						this.custom_error_message = `${e.response.data.owner} - ${
							e.response.data.messages[0]
						}`

						console.log(e)
					})
			} else this.register_error = false
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		validPassword() {
			var strongRegex = new RegExp(
				'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})'
			)
			var mediumRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})')
			var low = new RegExp('^(?=.{6,})')

			if (this.password_strong_level == 'strong') {
				return strongRegex.test(this.password)
			} else if (this.password_strong_level == 'medium') {
				return mediumRegex.test(this.password)
			} else {
				return low.test(this.password)
			}
		},
	},

	validations() {
		return {
			register: {
				registerUnique() {
					if (!this.register_error) return true
					else return false
				},
			},
			email: {
				required,
				email,
			},
			email_confirm: {
				required,
				email,
				sameAsEmail: sameAs('email'),
			},
			password: {
				required,
				validPassword() {
					return this.validPassword()
				},
			},
			password_confirm: {
				required,
				sameAsPassword: sameAs('password'),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
a
    text-decoration none
    color inherit
</style>
